/**
 * Language
 * @class
 * @constructor
 * @public
 */
class Language {
  /**
   * Constructor
   * @param {string} name The container to handle
   * @returns {object} options The options
   * @returns {class}
   */
  constructor() {
    this.languageSelects = document.querySelectorAll('[data-language]');

    // Engage engines
    this.languageSelects.forEach((component) => {
      this.init(component);
    });
  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init(component) {
    component.onchange = function(event) {
      location.href = event.target.value;
    };

    return this;
  }
}

module.exports = Language;
